<div class="version-container">
    <div class="spacer"></div>
      <a
        class="m-r-10 cursor-pointer"
        [matTooltip]= versionStr
        matTooltipClass="tooltip-multiline"
        matTooltipPosition="left"
        (click)="null" >
        <mat-icon color="accent">info</mat-icon>
      </a>
  </div>